// extracted by mini-css-extract-plugin
export var center = "_42-2";
export var clickableRow = "_42-5";
export var expandedRow = "_42-7";
export var hoverable = "_42-4";
export var left = "_42-1";
export var right = "_42-3";
export var row = "_42-0";
export var selectedRow = "_42-6";
export var summaryRow = "_42-8";